<template>
  <section id="compliance" class="compliance-block">
    <h2>{{ compliance.title }}</h2>
    <p v-for="(para, idx) in compliance.paragraphs" :key="'p-' + idx">{{ para }}</p>
    <ul>
      <li v-for="(line, idx) in compliance.bullets" :key="'b-' + idx">{{ line }}</li>
    </ul>
  </section>
</template>

<script>
import { MARKETING_COMPLIANCE } from '@/utils/seoSchema'

export default {
  name: 'AcademicComplianceNotice',
  data() {
    return {
      compliance: MARKETING_COMPLIANCE
    }
  }
}
</script>

<style scoped>
.compliance-block {
  margin-top: 32px;
  padding: 20px 22px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.compliance-block h2 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
}

.compliance-block p {
  font-size: 14px;
  line-height: 1.75;
  color: #475569;
  margin-bottom: 10px;
}

.compliance-block ul {
  margin: 8px 0 0;
  padding-left: 20px;
  font-size: 14px;
  line-height: 1.7;
  color: #475569;
}
</style>
